import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { type SupplierDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Req = {
  supplierId: number | undefined;
};

type Response = SupplierDto | undefined;

type Return = {
  isError: boolean;
  isGetting: boolean;
  supplierDetails: Response;
};

export const useGetSupplierDetails = (req: Req): Return => {
  const { suppliersApi } = useApiClient();

  const { data, isError, isPending } = useQuery<Response, AxiosError>({
    queryFn: async () => {
      if (!req.supplierId) {
        return;
      }
      const { data } = await suppliersApi.getSupplier(req.supplierId);
      return data;
    },
    queryKey: [QueryKeyEnum.SUPPLIER_DETAILS, req.supplierId],
  });

  return {
    isError: isError,
    isGetting: isPending,
    supplierDetails: data,
  };
};
